/* ==========================================================================
   Rutina paso a paso — el número de cada paso se "prende" (círculo relleno,
   ícono blanco) cuando ese paso queda centrado en la pantalla al scrollear.

   Cómo decide cuál está activo: en cada scroll, mide la distancia entre el
   centro de CADA paso y el centro de la pantalla, y activa el que tenga la
   distancia más chica. Siempre hay exactamente un paso activo — incluido
   al cargar la página, sin necesidad de scrollear primero.

   (La primera versión usaba IntersectionObserver con un rootMargin negativo
   del 45%. Es una técnica válida, pero deja casos donde ningún paso queda
   "activo" — por ejemplo mientras la franja central pasa por el espacio
   entre dos pasos — y eso se leía como "no pasa nada". Este cálculo directo
   no tiene ese hueco.)
   ========================================================================== */

(function () {
  'use strict';

  function iniciar(root) {
    if (root.dataset.stepsRoutineInit === 'true') return;
    root.dataset.stepsRoutineInit = 'true';

    var filas = Array.prototype.slice.call(root.querySelectorAll('[data-step]'));
    if (!filas.length) return;

    var pendiente = false;

    function actualizar() {
      pendiente = false;
      var centroPantalla = window.innerHeight / 2;
      var masCercana = filas[0];
      var menorDistancia = Infinity;

      filas.forEach(function (fila) {
        var rect = fila.getBoundingClientRect();
        var centroFila = rect.top + rect.height / 2;
        var distancia = Math.abs(centroFila - centroPantalla);
        if (distancia < menorDistancia) {
          menorDistancia = distancia;
          masCercana = fila;
        }
      });

      filas.forEach(function (fila) {
        fila.classList.toggle('is-active', fila === masCercana);
      });
    }

    function pedirActualizacion() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(actualizar);
    }

    pedirActualizacion();
    window.addEventListener('scroll', pedirActualizacion, { passive: true });
    window.addEventListener('resize', pedirActualizacion);
  }

  function iniciarTodas() {
    document.querySelectorAll('[data-steps-routine]').forEach(iniciar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodas);
  } else {
    iniciarTodas();
  }

  // el editor de Shopify vuelve a inyectar el HTML de la sección al editarla
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-steps-routine]');
    if (root) {
      root.dataset.stepsRoutineInit = 'false';
      iniciar(root);
    }
  });
})();
